import type { U3141ChildLotChain } from '../U3141Service';

function normStr(v: unknown): string {
  if (v == null) return '';
  return String(v).trim();
}

function normCorrections(v: unknown): string {
  return normStr(v);
}

function normConcordanceList(v: unknown): string {
  if (!Array.isArray(v)) return '';
  return v
    .map((e) => normStr(e))
    .filter(Boolean)
    .sort()
    .join('\u0001');
}

/** Compare le brouillon au snapshot post-resolve (champs métier + concordances). */
export function u3141IsGraphAddFormDirty(
  current: U3141ChildLotChain,
  snapshot: U3141ChildLotChain | null,
): boolean {
  if (!snapshot) return false;

  const cur = current?.lotDetail;
  const snap = snapshot.lotDetail;
  if (!cur || !snap) return false;

  if (normStr(cur.district?.id) !== normStr(snap.district?.id)) return true;
  if (normStr(cur.district?.propertyDistrict) !== normStr(snap.district?.propertyDistrict)) return true;
  if (normStr(cur.cadastre?.id) !== normStr(snap.cadastre?.id)) return true;
  if (normStr(cur.cadastre?.cadastre) !== normStr(snap.cadastre?.cadastre)) return true;
  if (normStr(cur.dateEstablishment) !== normStr(snap.dateEstablishment)) return true;
  if (normStr(cur.operationType) !== normStr(snap.operationType)) return true;
  if (normStr(cur.operationTypeInfo) !== normStr(snap.operationTypeInfo)) return true;
  if (normCorrections(cur.corrections) !== normCorrections(snap.corrections)) return true;
  if (cur.partieDeLot !== snap.partieDeLot) return true;
  if (normConcordanceList(cur.concordance) !== normConcordanceList(snap.concordance)) return true;

  return false;
}

export function u3141CloneChildLotChainSnapshot(child: U3141ChildLotChain): U3141ChildLotChain {
  return JSON.parse(JSON.stringify(child)) as U3141ChildLotChain;
}
